import * as React from "react";
import {Component} from "react";
import styles from "../../../styles/flyouts/superadmin/paper_sizes/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import {setNotification} from "../../../redux/actions/general/notification";
import {listPaperSizes, updatePaperSize} from "../../../redux/actions/table/superadmin/paper_sizes";
import EditPaperSizeForm from "../../../forms/superadmin/paper_sizes/EditPaperSizeForm";
import {listLocalization} from "../../../redux/actions/localization";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updatePaperSize(formData.id, _.omit(formData, ['id'])).then(() => {
                listPaperSizes();

                this.props.readAction(formData.id);

                listLocalization();

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditPaperSizeForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'width', 'height']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
